var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 23,
    rx: 11.5,
    stroke: "#CCCCCC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8242 6.96484V8.62891H15.9219V6.44922H17.2227V11.8047H15.9219V9.66016H13.8242V11.3945H8.80859V6.96484H13.8242ZM10.0977 10.3633H12.5352V7.99609H10.0977V10.3633ZM10.2383 13.293V12.2852H17.2227V15.0273H11.5508V15.8828H17.5625V16.9141H10.25V14.0664H15.9219V13.293H10.2383ZM24.6406 7.36328V8.42969H20.6211V10.3164H24.2188V11.3477H20.6211V13.5273C22.3555 13.5215 23.6797 13.457 25.2031 13.2109L25.332 14.2656C23.6621 14.5293 22.1738 14.582 20.2227 14.582H19.332V7.36328H24.6406ZM26.2578 17.043V6.44922H27.5703V17.043H26.2578ZM38.7734 14.6758V15.7656H29.0938V14.6758H38.7734ZM29.8906 8.47656V7.43359H37.9297V8.47656H36.3828V11.8516H37.8945V12.8828H29.9258V11.8516H31.4141V8.47656H29.8906ZM32.7148 11.8516H35.0938V8.47656H32.7148V11.8516ZM49.1445 14.7344V15.8125H39.4648V14.7344H43.6367V13.0117H40.6133V9.54297H46.707V8.23047H40.5898V7.17578H47.9961V10.5742H41.9141V11.9453H48.2422V13.0117H44.9258V14.7344H49.1445ZM58.6719 6.44922V11.9102H57.3711V6.44922H58.6719ZM50.0117 10.6094C50.3926 10.6094 50.7969 10.6035 51.2188 10.5977V8.13672H50.293V7.12891H56.0469V8.13672H55.0977V10.4395C55.5781 10.4043 56.0469 10.3574 56.4922 10.3047L56.5508 11.2422C54.4414 11.5762 52.0039 11.6406 50.1523 11.6406L50.0117 10.6094ZM51.5703 13.375V12.3555H58.6719V15.0859H52.8828V15.918H59.0117V16.9492H51.5938V14.1367H57.3828V13.375H51.5703ZM52.4727 10.5684C52.9297 10.5566 53.3926 10.5391 53.8555 10.5156V8.13672H52.4727V10.5684Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8.5V15.5",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 12H71.5",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiProfile);
export default __webpack_public_path__ + "static/media/multiProfile.92ca6963622e73915f247637d8b74d31.svg";
export { ForwardRef as ReactComponent };